/**
 * Extract speech-friendly text from an Expert message.
 *
 * - Strips markdown formatting (headers, bold, links, images)
 * - Removes FSCA disclaimer blocks
 * - Converts trade card-style data to natural sentences
 */

export function extractSpeechText(content: string): string {
  let text = content;

  // Remove FSCA disclaimer (common patterns)
  text = text.replace(
    /(?:\*{0,2})?(?:Disclaimer|FSCA|Financial Advisory).*?(?:\n\n|\n$|$)/gis,
    ''
  );
  text = text.replace(
    /(?:---\s*\n)?(?:\*{1,2})?(?:This (?:is not|does not constitute) financial advice).*?(?:\n\n|\n$|$)/gis,
    ''
  );

  // Strip markdown images
  text = text.replace(/!\[.*?\]\(.*?\)/g, '');

  // Convert markdown links to just the text
  text = text.replace(/\[([^\]]+)\]\(.*?\)/g, '$1');

  // Strip markdown headers
  text = text.replace(/^#{1,6}\s+/gm, '');

  // Strip bold/italic
  text = text.replace(/\*{1,3}(.*?)\*{1,3}/g, '$1');
  text = text.replace(/_{1,3}(.*?)_{1,3}/g, '$1');

  // Strip code blocks
  text = text.replace(/```[\s\S]*?```/g, '');
  text = text.replace(/`([^`]+)`/g, '$1');

  // Strip horizontal rules
  text = text.replace(/^---+$/gm, '');

  // Collapse multiple newlines
  text = text.replace(/\n{3,}/g, '\n\n');

  // Trim
  text = text.trim();

  return text;
}
